var _module = require('../../module');

require('../../../services/lr-touch');

_module.component('homeoptions', {
    bindings: {
        totalHomes: '@',
        heading: '@',
        options: '<',
        onGotoResults: '&',
        onSelect: '&'
    },
    controllerAs: 'homeoptions',
    controller: [
        '$log',

        function homeoptionsCtrl($log) {
            $log.debug('homeoptions');

            var _this = this;

            // Functions
            this.selectOption = function selectOption(value) {
                _this.onSelect({ $value: value });
            };

            this.makeMobile = function makeMobile(url) {
                return url.replace(/(@2x\.)/gi, '-mobile$1');
            };
        }
    ],
    template: require('./index.html')
});
